import { createContext } from 'react';
import { PageContextType } from '#page/contexts/PageContextType';

const PageContext = createContext<PageContextType>(null);

export { PageContext };
